import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { DataService } from '../../data.service';

/**
 *  FEGYELMI ELJÁRÁSOK – nyilvántartás és a kötelező értesítések (backend/fegyelmi.js)
 *
 *  Nkt. 58. § (3): a megindításról és a határozatról a tanulót és a kiskorú tanuló szülőjét a
 *  tanulmányi rendszeren keresztül is haladéktalanul értesíteni kell – ez az értesítés NEM közlés.
 *  A 20/2012. EMMI r. ugyanezt kéri az egyeztető eljárás felajánlásánál (53. § (3)) és a tárgyalás
 *  időpontjánál (56. § (2)). Ezeknél a lépéseknél a mentés azonnal kiküldi az értesítést
 *  (rendszerüzenet + push + semleges e-mail); a lépésnél látszik, kinek és hogyan ment ki.
 *
 *  Két helyen nyílik: Admin › Napló és értékelés › Fegyelmi eljárások (kezelés: igazgató, fegyelmi
 *  admin) és a /fegyelmi útvonalon (az osztályfőnök a saját osztályáét olvassa) – ott a saját
 *  fejléccel (`onallo`).
 */
@Component({
  selector: 'app-admin-fegyelmi',
  templateUrl: './fegyelmi.component.html',
  styleUrls: ['./fegyelmi.component.scss'],
})
export class AdminFegyelmiComponent implements OnInit {
  onallo = false;
  sajatIntezmeny: any;

  jog: any = null;
  kezel = false;
  lista: any[] = [];
  kereses = '';
  szuroAllapot = '';
  toltodik = false;
  hiba = '';

  /* új eljárás */
  ujNyitva = false;
  uj: any = this.uresUj();
  tanuloKeres = '';
  tanulok: any[] = [];

  /* adatlap */
  adatlap: any = null;
  fej: any = {};
  fejSzerkeszt = false;
  lepesUrlap: any = this.uresLepes();
  mentes = false;
  csaladiSzovegNyitva: Record<string, boolean> = {};
  naploNyitva = false;

  constructor(private http: HttpClient, private data: DataService, private route: ActivatedRoute, private router: Router) {}

  /**
   *  Véglegessé vált kizárás → kiléptetés (2026-11-02): a kiszolgáló `kileptetes` mezője mondja meg, nyitott-e
   *  még a jogviszony; a gomb a Kiléptetés képernyőt nyitja „Kizárás az iskolából” okkal (és nem
   *  tanköteles tanulónál a véglegessé válás napjával). A kiléptetés után a KIR-bejelentés-figyelő
   *  veszi fel a megszűnést.
   */
  kileptetesNyit() {
    const k = this.adatlap?.kileptetes;
    const okt = this.adatlap?.eljaras?.oktazon;
    if (!k || !okt) return;
    this.router.navigate(['/admin/tanulo-kilepes'], { queryParams: { tanulo: okt, ok_kod: k.ok_kod, ...(k.datum ? { datum: k.datum } : {}) } });
  }

  async ngOnInit() {
    this.onallo = !!this.route.snapshot.data?.['onallo'];
    this.sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    try {
      this.jog = await firstValueFrom(this.http.get<any>(`/api/fegyelmi/jog/${this.int}`));
      this.kezel = !!this.jog?.kezel;
      this.listakEpit();
    } catch (e: any) {
      this.hiba = e?.error?.error || 'A jogosultság lekérdezése nem sikerült.';
      return;
    }
    await this.betolt();
  }

  get int(): string { return String(this.sajatIntezmeny?.intezmenyId || '').replace(/^\/+|\/+$/g, ''); }

  /*  A VÁLASZTÓK LISTÁI EGYSZER SZÁMOLVA (a jogosultság betöltésekor), nem getterként: a getter
   *  minden változásészleléskor új tömböt adott, az *ngFor újrarajzolta az ion-select opcióit, az
   *  ion-select opció-figyelője pedig újabb változásészlelést indított – végtelen kör, a lap nem
   *  válaszolt. */
  fajtaLista: { kulcs: string; nev: string; kotelezo: boolean; jog: string }[] = [];
  buntetesLista: { kulcs: string; nev: string }[] = [];
  okLista: { kulcs: string; nev: string }[] = [];
  allapotLista: { kulcs: string; nev: string }[] = [];

  private listakEpit() {
    const f = this.jog?.fajtak || {};
    this.fajtaLista = Object.keys(f).map((k) => ({ kulcs: k, nev: f[k].nev, kotelezo: !!f[k].kotelezo, jog: f[k].jog }));
    const b = this.jog?.buntetesek || {};
    this.buntetesLista = Object.keys(b).map((k) => ({ kulcs: k, nev: b[k] }));
    const o = this.jog?.megszuntetes_okok || {};
    this.okLista = Object.keys(o).map((k) => ({ kulcs: k, nev: o[k] }));
    const a = this.jog?.allapotok || {};
    this.allapotLista = Object.keys(a).map((k) => ({ kulcs: k, nev: a[k] }));
  }
  get aktFajta(): any { return this.jog?.fajtak?.[this.lepesUrlap.fajta] || null; }

  private uresUj() {
    return { oktazon: '', tanulo_nev: '', kotelessegszeges: '', kotelessegszeges_napja: '', bunteto_kozles_napja: '',
      tanulo_kerte: false, sertett_fel: '', ugyszam: '' };
  }
  private uresLepes(): any {
    return { fajta: '', datum: this.maIso(), ertesites: false, megjegyzes: '', adatok: {} as any };
  }
  private maIso(): string {
    const d = new Date();
    const k = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${k(d.getMonth() + 1)}-${k(d.getDate())}`;
  }

  async betolt() {
    this.toltodik = true; this.hiba = '';
    try {
      const u = new URLSearchParams();
      if (this.kereses) u.set('q', this.kereses);
      if (this.szuroAllapot) u.set('allapot', this.szuroAllapot);
      const r: any = await firstValueFrom(this.http.get<any>(`/api/fegyelmi/lista/${this.int}?${u.toString()}`));
      this.lista = r?.eljarasok || [];
      this.kezel = !!r?.kezel;
    } catch (e: any) {
      this.hiba = e?.error?.error || 'A lista betöltése nem sikerült.';
    }
    this.toltodik = false;
  }

  /* ───────────── új eljárás */

  ujEljaras() { this.uj = this.uresUj(); this.tanulok = []; this.tanuloKeres = ''; this.ujNyitva = true; this.adatlap = null; }

  async tanulokKeres() {
    try {
      this.tanulok = await firstValueFrom(this.http.get<any[]>(
        `/api/fegyelmi/tanulok/${this.int}?q=${encodeURIComponent(this.tanuloKeres || '')}`));
    } catch { this.tanulok = []; }
  }

  tanuloValt() {
    const t = this.tanulok.find((x) => String(x.oktazon) === String(this.uj.oktazon));
    this.uj.tanulo_nev = t ? t.nev : '';
  }

  async ujMent() {
    this.mentes = true;
    try {
      const r: any = await firstValueFrom(this.http.post(`/api/fegyelmi/uj/${this.int}`, this.uj));
      this.data.sendToast('Az eljárás felvéve. Következő lépés: az egyeztető eljárás felajánlása (53. § (3)).', 'success');
      this.ujNyitva = false;
      await this.betolt();
      if (r?.id) await this.megnyit(r.id);
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
    }
    this.mentes = false;
  }

  /* ───────────── adatlap */

  async megnyit(id: string) {
    try {
      this.adatlap = await firstValueFrom(this.http.get<any>(`/api/fegyelmi/eljaras/${id}/${this.int}`));
      const e = this.adatlap.eljaras;
      this.fej = { ugyszam: e.ugyszam || '', kotelessegszeges: e.kotelessegszeges || '', kotelessegszeges_napja: e.kotelessegszeges_napja || '',
        bunteto_kozles_napja: e.bunteto_kozles_napja || '', tanulo_kerte: !!Number(e.tanulo_kerte), sertett_fel: e.sertett_fel || '' };
      this.fejSzerkeszt = false;
      this.ujNyitva = false;
      this.lepesUrlap = this.uresLepes();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az eljárás nem nyitható meg.', 'error');
    }
  }

  async frissit() { if (this.adatlap?.eljaras?.id) await this.megnyit(this.adatlap.eljaras.id); }

  bezar() { this.adatlap = null; this.betolt(); }

  async fejMent() {
    try {
      await firstValueFrom(this.http.put(`/api/fegyelmi/eljaras/${this.adatlap.eljaras.id}/${this.int}`, this.fej));
      this.data.sendToast('Mentve (a változás a naplóba került).', 'success');
      await this.frissit();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
    }
  }

  async eljarasTorol() {
    const ok = prompt('A törlés oka (csak akkor törölhető, ha még semmilyen értesítés nem ment ki):');
    if (!ok) return;
    try {
      await firstValueFrom(this.http.request('delete', `/api/fegyelmi/eljaras/${this.adatlap.eljaras.id}/${this.int}`, { body: { ok } }));
      this.data.sendToast('Törölve.', 'success');
      this.bezar();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A törlés nem sikerült.', 'error');
    }
  }

  fajtaValt() {
    const f = this.aktFajta;
    this.lepesUrlap.adatok = {};
    this.lepesUrlap.ertesites = f ? (f.kotelezo || !!f.alap) : false;
    if (this.lepesUrlap.fajta === 'meginditas') this.lepesUrlap.adatok.kotelessegszeges = this.adatlap?.eljaras?.kotelessegszeges || '';
    if (this.lepesUrlap.fajta === 'egyezteto_felajanlas') this.lepesUrlap.adatok.kotelessegszeges = this.adatlap?.eljaras?.kotelessegszeges || '';
    if (this.lepesUrlap.fajta === 'hatarozat') this.lepesUrlap.adatok.dontes = 'buntetes';
  }

  async lepesMent(megerosit = false): Promise<void> {
    this.mentes = true;
    const torzs = { ...this.lepesUrlap, megerosit };
    try {
      const r: any = await firstValueFrom(this.http.post(`/api/fegyelmi/eljaras/${this.adatlap.eljaras.id}/lepes/${this.int}`, torzs));
      this.data.sendToast(r?.ertesites
        ? 'Rögzítve – az értesítés kimegy a tanulónak (kiskorúnál a gondviselőknek is); nem minősül közlésnek.'
        : 'Rögzítve.', 'success');
      this.mentes = false;
      //  Az értesítés háttérben megy ki; egy pillanat múlva frissítünk, hogy az eredmény látsszon.
      await this.frissit();
      if (r?.ertesites) setTimeout(() => this.frissit(), 2500);
      return;
    } catch (e: any) {
      const figy: string[] = e?.error?.figyelmeztetesek || [];
      if (e?.status === 409 && figy.length) {
        this.mentes = false;
        if (confirm(`Figyelem:\n\n- ${figy.join('\n- ')}\n\nMégis rögzíted?`)) await this.lepesMent(true);
        return;
      }
      this.data.sendToast(e?.error?.error || 'A rögzítés nem sikerült.', 'error');
    }
    this.mentes = false;
  }

  async visszavon(l: any) {
    const ok = prompt(`A(z) „${l.nev}” lépés visszavonásának oka:\n(A már kiküldött értesítés a címzetteknél megmarad; ha a tartalma téves volt, rögzíts új lépést.)`);
    if (!ok) return;
    try {
      await firstValueFrom(this.http.post(`/api/fegyelmi/lepes/${l.id}/visszavon/${this.int}`, { ok }));
      this.data.sendToast('Visszavonva.', 'success');
      await this.frissit();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A visszavonás nem sikerült.', 'error');
    }
  }

  async ujrakuld(l: any) {
    try {
      await firstValueFrom(this.http.post(`/api/fegyelmi/lepes/${l.id}/ertesites/${this.int}`, {}));
      this.data.sendToast('Az értesítés kiment.', 'success');
      await this.frissit();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az értesítés nem ment ki.', 'error');
    }
  }

  ertesitesSzoveg(l: any): string {
    const e = l.ertesites_eredmeny || {};
    if (l.ertesites === 'nincs') return 'nincs értesítés';
    if (l.ertesites === 'var' || l.ertesites === 'folyamatban') return 'kiküldés folyamatban…';
    if (l.ertesites === 'hiba') return `HIBA: ${e.hiba || 'a kiküldés nem sikerült'}`;
    const reszek: string[] = [];
    if (e.uzenet) reszek.push(`rendszerüzenet: tanuló${e.uzenet.gondviselo ? ` + ${e.uzenet.gondviselo} gondviselő` : ''}`);
    if (!e.kiskoru) reszek.push('nagykorú tanuló – a gondviselők nem címzettek');
    if (e.push) reszek.push(e.push.eszkoz ? `push: ${e.push.eredmeny || e.push.eszkoz + ' eszköz'}` : 'push: nincs regisztrált eszköz');
    if (e.email) {
      if (!e.email.beallitva) reszek.push('e-mail: nincs levélküldő');
      else reszek.push(`e-mail: ${e.email.kuldve} elküldve${e.email.cim_nelkul ? `, ${e.email.cim_nelkul} címzettnek nincs címe` : ''}${e.email.hibak?.length ? `, hiba: ${e.email.hibak[0]}` : ''}`);
    }
    return reszek.join(' · ');
  }

  napLabel(f: string): string {
    if (f === 'kozles') return 'A postai kézhezvétel napja';
    if (f === 'fellebbezes') return 'A fellebbezés beérkezésének napja';
    if (f === 'vegleges') return 'A véglegessé válás napja';
    if (f === 'hatarozat') return 'A kihirdetés napja';
    if (f === 'meginditas') return 'A megindítás napja';
    return 'A lépés napja';
  }

  hatalyMax(k: string): number { return Number(this.jog?.hataly_max_honap?.[k]) || 0; }
  buntetesNev(k: string): string { return this.jog?.buntetesek?.[k] || k || ''; }
  okNev(k: string): string { return this.jog?.megszuntetes_okok?.[k] || k || ''; }

  /* ───────────── iratok */

  async iratFeltolt(ev: any) {
    const f: File | undefined = ev?.target?.files?.[0];
    if (!f) return;
    const fd = new FormData();
    fd.append('file', f, f.name);
    try {
      await firstValueFrom(this.http.post(`/api/fegyelmi/eljaras/${this.adatlap.eljaras.id}/irat/${this.int}`, fd));
      this.data.sendToast('Az irat feltöltve.', 'success');
      await this.frissit();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A feltöltés nem sikerült.', 'error');
    }
    if (ev?.target) ev.target.value = '';
  }

  /** A letöltés tokennel megy (blob), nem sima hivatkozással – a sima link nem vinne jegyet. */
  async iratMegnyit(i: any) {
    try {
      const blob = await firstValueFrom(this.http.get(`/api/fegyelmi/irat/${i.id}/${this.int}`, { responseType: 'blob' }));
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch {
      this.data.sendToast('Az irat nem nyitható meg.', 'error');
    }
  }

  async iratTorol(i: any) {
    if (!confirm(`Törlöd az iratot? (${i.nev})`)) return;
    try {
      await firstValueFrom(this.http.request('delete', `/api/fegyelmi/irat/${i.id}/${this.int}`, { body: {} }));
      await this.frissit();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A törlés nem sikerült.', 'error');
    }
  }
}
